<template>
	<v-dialog
		v-model="showDialog"
		width="1200px"
		:fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
		:transition="$vuetify.breakpoint.mdAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">受注内容確認書承認</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<div class="pa-2">
				<v-row justify="end" no-gutters>
					<v-btn color="secondary" @click="openMatterDialog"> 案件情報確認 </v-btn>
				</v-row>
				<v-form ref="form" v-model="valid">
					<v-row no-gutters class="text-body-2">
						<v-col cols="12" md="6" class="pr-md-2">
							<table width="100%" class="mt-4">
							<!-- TODO valueをサンプルデータから変更 不足カラム多数要確認 -->
								<tbody>
									<ConfirmRecord
										:name="'得意先'"
										:value="matter.regular_customer_company.name"
									/>
									<ConfirmRecord
										:name="'納入先'"
										:value="matter.delivery_company_name"
									/>
									<ConfirmRecord
										:name="'エンドユーザー'"
										:value="matter.customer_company.name"
									/>
									<ConfirmRecord
										:name="'プラントメーカー'"
										:value="
											matter.plant_customer_company
												? matter.plant_customer_company.name
												: ''
										"
									/>
									<ConfirmRecord :name="'備考'" :value="''" />
									<ConfirmRecord :name="'見積No'" :value="'KG-18-OYM-147'" />
									<ConfirmRecord :name="'注文書No'" :value="'E-160'" />
									<ConfirmRecord :name="'図書No'" :value="''" />
									<ConfirmRecord :name="'引合仕様検討No'" :value="''" />
									<ConfirmRecord :name="'原価No'" :value="''" />
									<ConfirmRecord :name="'工事引合仕様書No'" :value="''" />
									<ConfirmRecord :name="'顧客書類'" :value="'顧客書類.pdf'" />
									<ConfirmRecord
										:name="'ライニング母材（缶体）手配者'"
										:value="order_confirmation.source_of_base_material_i18n"
									/>
									<ConfirmRecord
										:name="'ライニング母材（缶体）支給予定日'"
										:value="common.formatDate(order_confirmation.scheduled_date_of_payment)"
									/>
									<ConfirmRecord :name="'承認予定日'" :value="''" />
									<ConfirmRecord :name="'社内書類'" :value="'3EC0625'" />
									<ConfirmRecord :name="'社内図書特記事項'" :value="''" />
									<ConfirmRecord
										:name="'塗装'"
										:value="order_confirmation.exists_coating ? '有' : '無'"
									/>
									<ConfirmRecord
										:name="'塗装補足事項'"
										:value="order_confirmation.coating_content"
									/>
									<ConfirmRecord
										:name="'工程写真'"
										:value="order_confirmation.exists_process_photo ? '有' : '無'"
									/>
									<ConfirmRecord
										:name="'工程写真補足事項'"
										:value="order_confirmation.process_photo_content"
									/>
									<ConfirmRecord
										:name="'水協検査'"
										:value="order_confirmation.exists_water_works ? '有' : '無'"
									/>
									<ConfirmRecord :name="'水協検査方法'" :value="''" />
									<ConfirmRecord
										:name="'水協検査補足事項'"
										:value="order_confirmation.water_works_content"
									/>
								</tbody>
							</table>
						</v-col>
						<v-col cols="12" md="6" class="pl-md-2">
							<table width="100%" class="mt-4">
								<tbody>
									<ConfirmRecord
										:name="'立会検査'"
										:value="order_confirmation.exists_witness ? '有' : '無'"
									/>
									<ConfirmRecord
										:name="'立会検査補足事項'"
										:value="order_confirmation.witness_content"
									/>
									<ConfirmRecord
										:name="'梱包指定'"
										:value="order_confirmation.exists_packaging ? '有' : '無'"
									/>
									<ConfirmRecord
										:name="'梱包指定補足事項'"
										:value="order_confirmation.packaging_content"
									/>
									<ConfirmRecord
										:name="'出荷時添付書類'"
										:value="order_confirmation.exists_attached_file ? '有' : '無'"
									/>
									<ConfirmRecord :name="'出荷時添付書類対象'" :value="''" />
									<ConfirmRecord :name="'出荷時添付書類補足事項'" :value="''" />
									<ConfirmRecord :name="'出荷時添付書類部数'" :value="''" />
									<ConfirmRecord
										:name="'輸送手配元'"
										:value="order_confirmation.source_of_transport_i18n"
									/>
									<ConfirmRecord
										:name="'KG手配時の輸送方法'"
										:value="order_confirmation.transport"
									/>
									<ConfirmRecord :name="'輸送補足事項'" :value="''" />
									<ConfirmRecord :name="'製品品番'" :value="'2023E00134-01'" />
									<ConfirmRecord :name="'品名'" :value="'300A 1山 ゴム伸縮継手'" />
									<ConfirmRecord :name="'図番'" :value="'3EC0625'" />
									<ConfirmRecord :name="'数量'" :value="'2'" />
									<ConfirmRecord :name="'納期日'" :value="'2023/9/20'" />
									<ConfirmRecord :name="'単価'" :value="'145,000'" />
									<ConfirmRecord :name="'税抜き総額'" :value="'29,000'" />
									<ConfirmRecord :name="'摘要１'" :value="''" />
									<ConfirmRecord :name="'摘要２'" :value="''" />
								</tbody>
							</table>
						</v-col>
					</v-row>
				</v-form>
			</div>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" text @click="showDialog = false"> 戻る </v-btn>
				<v-btn :disabled="!valid" color="primary" text @click="$emit('submit-form')">
					{{ actionText }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import common from "../../../helper/common"
import ConfirmRecord from "../../shared/ConfirmRecord.vue"
export default {
	components: {
		ConfirmRecord,
	},
	props: {
		order_confirmation: {
			type: Object,
			default: () => ({}),
		},
		matter: {
			type: Object,
			default: () => ({}),
		},
		dialog: {
			type: Boolean,
			required: false,
		},
		matter: {
			type: Object,
			required: false,
		},
		actionText: {
			type: String,
			required: false,
			default: "承認",
		},
	},
	data() {
		return {
			headers: [],
			valid: false,
			common,
		}
	},
	methods: {
		openMatterDialog() {},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(value) {
				this.$emit("update:dialog", value)
			},
		},
	},
}
</script>